const THEME_MODE_NCOB = Object.freeze({
  neutral: 'neutral',
  slick: 'slick',
  dark: 'dark',
});

// noinspection JSUnusedGlobalSymbols
export default THEME_MODE_NCOB;
